import Vue from 'vue'

import Meta from 'vue-meta'
import ClientOnly from 'vue-client-only'
import NoSsr from 'vue-no-ssr'
import { createRouter } from './router.js'
import NuxtChild from './components/nuxt-child.js'
import NuxtError from '../layouts/error.vue'
import Nuxt from './components/nuxt.js'
import App from './App.js'
import { setContext, getLocation, getRouteData, normalizeError } from './utils'

/* Plugins */

import nuxt_plugin_plugin_75c7d164 from 'nuxt_plugin_plugin_75c7d164' // Source: ./composition-api/plugin.mjs (mode: 'all')
import nuxt_plugin_recaptcha_3020e001 from 'nuxt_plugin_recaptcha_3020e001' // Source: ./recaptcha.js (mode: 'all')
import nuxt_plugin_pluginutils_4cbab9e9 from 'nuxt_plugin_pluginutils_4cbab9e9' // Source: ./nuxt-i18n/plugin.utils.js (mode: 'all')
import nuxt_plugin_pluginrouting_82171e18 from 'nuxt_plugin_pluginrouting_82171e18' // Source: ./nuxt-i18n/plugin.routing.js (mode: 'all')
import nuxt_plugin_pluginmain_094f3efb from 'nuxt_plugin_pluginmain_094f3efb' // Source: ./nuxt-i18n/plugin.main.js (mode: 'all')
import nuxt_plugin_portalvue_2038cd01 from 'nuxt_plugin_portalvue_2038cd01' // Source: ./portal-vue.js (mode: 'all')
import nuxt_plugin_deviceplugin_64e4d01d from 'nuxt_plugin_deviceplugin_64e4d01d' // Source: ./device.plugin.js (mode: 'all')
import nuxt_plugin_BreadcrumbContext_678700d6 from 'nuxt_plugin_BreadcrumbContext_678700d6' // Source: ../plugins/BreadcrumbContext.ts (mode: 'all')
import nuxt_plugin_HeaderContext_746990c2 from 'nuxt_plugin_HeaderContext_746990c2' // Source: ../plugins/HeaderContext.ts (mode: 'all')
import nuxt_plugin_SmoothScrollPolyfill_65e89062 from 'nuxt_plugin_SmoothScrollPolyfill_65e89062' // Source: ../plugins/SmoothScrollPolyfill.ts (mode: 'all')
import nuxt_plugin_VeeValidate_f87f2016 from 'nuxt_plugin_VeeValidate_f87f2016' // Source: ../plugins/VeeValidate.ts (mode: 'all')
import nuxt_plugin_Referrer_2c39481a from 'nuxt_plugin_Referrer_2c39481a' // Source: ../plugins/Referrer.ts (mode: 'all')
import nuxt_plugin_VueVimeoPlayer_6b9c025a from 'nuxt_plugin_VueVimeoPlayer_6b9c025a' // Source: ../plugins/VueVimeoPlayer.ts (mode: 'client')
import nuxt_plugin_VCalendar_4190a626 from 'nuxt_plugin_VCalendar_4190a626' // Source: ../plugins/VCalendar.ts (mode: 'client')
import nuxt_plugin_SafariOverflowContainer_957d963c from 'nuxt_plugin_SafariOverflowContainer_957d963c' // Source: ../plugins/SafariOverflowContainer.ts (mode: 'client')
import nuxt_plugin_meta_25069514 from 'nuxt_plugin_meta_25069514' // Source: ./composition-api/meta.mjs (mode: 'all')

// Component: <ClientOnly>
Vue.component(ClientOnly.name, ClientOnly)

// TODO: Remove in Nuxt 3: <NoSsr>
Vue.component(NoSsr.name, {
  ...NoSsr,
  render (h, ctx) {
    if (process.client && !NoSsr._warned) {
      NoSsr._warned = true

      console.warn('<no-ssr> has been deprecated and will be removed in Nuxt 3, please use <client-only> instead')
    }
    return NoSsr.render(h, ctx)
  }
})

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild)
Vue.component('NChild', NuxtChild)

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>
Vue.component(Nuxt.name, Nuxt)

Object.defineProperty(Vue.prototype, '$nuxt', {
  get() {
    const globalNuxt = this.$root.$options.$nuxt
    if (process.client && !globalNuxt && typeof window !== 'undefined') {
      return window.$nuxt
    }
    return globalNuxt
  },
  configurable: true
})

Vue.use(Meta, {"keyName":"head","attribute":"data-n-head","ssrAttribute":"data-n-head-ssr","tagIDKeyName":"hid"})

const defaultTransition = {"name":"page","mode":"out-in","appear":false,"appearClass":"appear","appearActiveClass":"appear-active","appearToClass":"appear-to"}

async function createApp(ssrContext, config = {}) {
  const router = await createRouter(ssrContext, config)

  // Create Root instance

  // here we inject the router and store to all child components,
  // making them available everywhere as `this.$router` and `this.$store`.
  const app = {
    head: function() {
    if (!this.$nuxtI18nHead) {
      return;
    }

    const i18nHead = this.$nuxtI18nHead({ addSeoAttributes: true });
    const filteredLinks = i18nHead.link.filter((link) => link.rel === 'canonical');

    return {
      title: 'Digital Colliers',
      htmlAttrs: {
        ...i18nHead.htmlAttrs },

      meta: [
      { charset: 'utf-8' },
      { name: 'viewport', content: 'width=device-width, initial-scale=1' },
      {
        hid: 'description',
        name: 'description',
        content: 'Digital Colliers' },

      { name: 'msapplication-TileColor', content: '#f6faff' },
      { name: 'theme-color', content: '#fffffe' },
      { name: 'theme-color', content: '#fffffe', media: '(prefers-color-scheme: light)' },
      { name: 'theme-color', content: '#0E1418', media: '(prefers-color-scheme: dark)' },
      ...i18nHead.meta],

      link: [
      {
        rel: 'apple-touch-icon',
        sizes: '180x180',
        href: '/favicon/apple-touch-icon.png' },

      {
        rel: 'icon',
        type: 'image/png',
        sizes: '32x32',
        href: '/favicon/favicon-32x32.png' },

      {
        rel: 'icon',
        type: 'image/png',
        sizes: '16x16',
        href: '/favicon/favicon-16x16.png' },

      { rel: 'manifest', href: '/favicon/site.webmanifest' },
      {
        rel: 'mask-icon',
        href: '/favicon/safari-pinned-tab.svg',
        color: '#4368ea' },

      ...filteredLinks] };
  },

    router,
    nuxt: {
      defaultTransition,
      transitions: [defaultTransition],
      setTransitions (transitions) {
        if (!Array.isArray(transitions)) {
          transitions = [transitions]
        }
        transitions = transitions.map((transition) => {
          if (!transition) {
            transition = defaultTransition
          } else if (typeof transition === 'string') {
            transition = Object.assign({}, defaultTransition, { name: transition })
          } else {
            transition = Object.assign({}, defaultTransition, transition)
          }
          return transition
        })
        this.$options.nuxt.transitions = transitions
        return transitions
      },

      err: null,
      dateErr: null,
      error (err) {
        err = err || null
        app.context._errored = Boolean(err)
        err = err ? normalizeError(err) : null
        let nuxt = app.nuxt // to work with @vue/composition-api, see https://github.com/nuxt/nuxt.js/issues/6517#issuecomment-573280207
        if (this) {
          nuxt = this.nuxt || this.$options.nuxt
        }
        nuxt.dateErr = Date.now()
        nuxt.err = err
        // Used in src/server.js
        if (ssrContext) {
          ssrContext.nuxt.error = err
        }
        return err
      }
    },
    ...App
  }

  const next = ssrContext ? ssrContext.next : location => app.router.push(location)
  // Resolve route
  let route
  if (ssrContext) {
    route = router.resolve(ssrContext.url).route
  } else {
    const path = getLocation(router.options.base, router.options.mode)
    route = router.resolve(path).route
  }

  // Set context to app.context
  await setContext(app, {
    route,
    next,
    error: app.nuxt.error.bind(app),
    payload: ssrContext ? ssrContext.payload : undefined,
    req: ssrContext ? ssrContext.req : undefined,
    res: ssrContext ? ssrContext.res : undefined,
    beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
    ssrContext
  })

  function inject(key, value) {
    if (!key) {
      throw new Error('inject(key, value) has no key provided')
    }
    if (value === undefined) {
      throw new Error(`inject('${key}', value) has no value provided`)
    }

    key = '$' + key
    // Add into app
    app[key] = value
    // Add into context
    if (!app.context[key]) {
      app.context[key] = value
    }

    // Check if plugin not already installed
    const installKey = '__nuxt_' + key + '_installed__'
    if (Vue[installKey]) {
      return
    }
    Vue[installKey] = true
    // Call Vue.use() to install the plugin into vm
    Vue.use(() => {
      if (!Object.prototype.hasOwnProperty.call(Vue.prototype, key)) {
        Object.defineProperty(Vue.prototype, key, {
          get () {
            return this.$root.$options[key]
          }
        })
      }
    })
  }

  // Inject runtime config as $config
  inject('config', config)

  // Add enablePreview(previewData = {}) in context for plugins
  if (process.static && process.client) {
    app.context.enablePreview = function (previewData = {}) {
      app.previewData = Object.assign({}, previewData)
      inject('preview', previewData)
    }
  }
  // Plugin execution

  if (typeof nuxt_plugin_plugin_75c7d164 === 'function') {
    await nuxt_plugin_plugin_75c7d164(app.context, inject)
  }

  if (typeof nuxt_plugin_recaptcha_3020e001 === 'function') {
    await nuxt_plugin_recaptcha_3020e001(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginutils_4cbab9e9 === 'function') {
    await nuxt_plugin_pluginutils_4cbab9e9(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginrouting_82171e18 === 'function') {
    await nuxt_plugin_pluginrouting_82171e18(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginmain_094f3efb === 'function') {
    await nuxt_plugin_pluginmain_094f3efb(app.context, inject)
  }

  if (typeof nuxt_plugin_portalvue_2038cd01 === 'function') {
    await nuxt_plugin_portalvue_2038cd01(app.context, inject)
  }

  if (typeof nuxt_plugin_deviceplugin_64e4d01d === 'function') {
    await nuxt_plugin_deviceplugin_64e4d01d(app.context, inject)
  }

  if (typeof nuxt_plugin_BreadcrumbContext_678700d6 === 'function') {
    await nuxt_plugin_BreadcrumbContext_678700d6(app.context, inject)
  }

  if (typeof nuxt_plugin_HeaderContext_746990c2 === 'function') {
    await nuxt_plugin_HeaderContext_746990c2(app.context, inject)
  }

  if (typeof nuxt_plugin_SmoothScrollPolyfill_65e89062 === 'function') {
    await nuxt_plugin_SmoothScrollPolyfill_65e89062(app.context, inject)
  }

  if (typeof nuxt_plugin_VeeValidate_f87f2016 === 'function') {
    await nuxt_plugin_VeeValidate_f87f2016(app.context, inject)
  }

  if (typeof nuxt_plugin_Referrer_2c39481a === 'function') {
    await nuxt_plugin_Referrer_2c39481a(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_VueVimeoPlayer_6b9c025a === 'function') {
    await nuxt_plugin_VueVimeoPlayer_6b9c025a(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_VCalendar_4190a626 === 'function') {
    await nuxt_plugin_VCalendar_4190a626(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_SafariOverflowContainer_957d963c === 'function') {
    await nuxt_plugin_SafariOverflowContainer_957d963c(app.context, inject)
  }

  if (typeof nuxt_plugin_meta_25069514 === 'function') {
    await nuxt_plugin_meta_25069514(app.context, inject)
  }

  // Lock enablePreview in context
  if (process.static && process.client) {
    app.context.enablePreview = function () {
      console.warn('You cannot call enablePreview() outside a plugin.')
    }
  }

  // Wait for async component to be resolved first
  await new Promise((resolve, reject) => {
    // Ignore 404s rather than blindly replacing URL in browser
    if (process.client) {
      const { route } = router.resolve(app.context.route.fullPath)
      if (!route.matched.length) {
        return resolve()
      }
    }
    router.replace(app.context.route.fullPath, resolve, (err) => {
      // https://github.com/vuejs/vue-router/blob/v3.4.3/src/util/errors.js
      if (!err._isRouter) return reject(err)
      if (err.type !== 2 /* NavigationFailureType.redirected */) return resolve()

      // navigated to a different route in router guard
      const unregister = router.afterEach(async (to, from) => {
        if (process.server && ssrContext && ssrContext.url) {
          ssrContext.url = to.fullPath
        }
        app.context.route = await getRouteData(to)
        app.context.params = to.params || {}
        app.context.query = to.query || {}
        unregister()
        resolve()
      })
    })
  })

  return {
    app,
    router
  }
}

export { createApp, NuxtError }
